import { Injectable } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/shared/enum';

@Injectable({
  providedIn: 'root',
})
export class ActivityDomainService {
  constructor(private commonService: CommonService) {}

  getPrintDetailsLink(transactionsId: any, transactionType: any, transactionSubType: any) {
    return this.commonService.API_GET(
      EndPoints.GetPrintDetails +
        `?TransactionsId=${transactionsId}&TransactionType=${transactionType}&SubType=${transactionSubType}`,
      false
    );
  }

  getActivityRecords(
    siteId: any,
    startPeriod: any,
    endPeriod: any,
    searchText: any,
    programPeriodId: any,
    tagIds: any,
    transactionSubType: any,
    activityType: any,
    sortOrder: any,
    sortField: any,
    page: any,
    pageSize: any,
    isNonAlc: boolean
  ) {
    const queryParams =
      activityType == 3
        ? {
            SiteId: siteId,
            StartPeriod: startPeriod,
            EndPeriod: endPeriod,
            SearchText: searchText,
            ProgramPeriodId: programPeriodId,
            TagIds: tagIds,
            TransactionSubType: transactionSubType,
            ActivityType: activityType,
            SortOrder: sortOrder,
            SortField: sortField,
            Page: page,
            PageSize: pageSize,
            isNonAlc: isNonAlc,
          }
        : {
            SiteId: siteId,
            SearchText: searchText,
            ProgramPeriodId: programPeriodId,
            TagIds: tagIds,
            TransactionSubType: transactionSubType,
            ActivityType: activityType,
            SortOrder: sortOrder,
            SortField: sortField,
            Page: page,
            PageSize: pageSize,
            isNonAlc: isNonAlc,
          };

    return this.commonService.API_POST(EndPoints.GetActivities, queryParams, false);
  }

  getActivityRecordsV2(
    siteId: any,
    startPeriod: any,
    endPeriod: any,
    searchText: any,
    transactionSubType: any,
    activityType: any,
    sortOrder: any,
    sortField: any,
    page: any,
    pageSize: any,
    isNonAlc: boolean,
    filterCompany: any,
    filterStatus: any,
    filterTransactions: any,
    filterProgram: any,
    filterTag: any
  ) {
    const queryParams =
      activityType == 3
        ? {
            SiteId: siteId,
            StartPeriod: startPeriod,
            EndPeriod: endPeriod,
            SearchText: searchText,
            TransactionSubType: transactionSubType,
            ActivityType: activityType,
            SortOrder: sortOrder,
            SortField: sortField,
            Page: page,
            PageSize: pageSize,
            isNonAlc: isNonAlc,
            CompanyDisplayName: filterCompany,
            transactionTypes: filterTransactions,
            programPeriodId: filterProgram,
            tagIds: filterTag,
          }
        : {
            SiteId: siteId,
            SearchText: searchText,
            TransactionSubType: transactionSubType,
            ActivityType: activityType,
            SortOrder: sortOrder,
            SortField: sortField,
            Page: page,
            PageSize: pageSize,
            isNonAlc: isNonAlc,
            CompanyDisplayName: filterCompany,
            Status: filterStatus,
          };

    return this.commonService.API_POST(EndPoints.GetActivitiesV2, queryParams, false);
  }

  getActivityCounts(siteId: any) {
    return this.commonService.API_GET(EndPoints.GetActivityCounts + `?siteId=${siteId}`, false);
  }

  getActivitiesCounts(requestBody: any) {
    return this.commonService.API_POST(EndPoints.GetActivitiesCounts, requestBody, false);
  }

  contactInvestor(requestBody: any) {
    return this.commonService.API_POST(EndPoints.ContactInvestor, requestBody, false);
  }

  getAnnouncements(siteId: any) {
    return this.commonService.API_GET(EndPoints.GetAnnouncement + `?SiteId=${siteId}`, false);
  }

  clearAnnouncements(requestBody: any) {
    return this.commonService.API_POST(EndPoints.UpdateSeenAnnouncement, '"' + requestBody + '"', false);
  }

  openViewInvoiceURL(transactionsId: any, transactionsType: any) {
    return this.commonService.API_GET(
      EndPoints.GetInvoiceURL + `?transactionsId=${transactionsId}&transactionsType=${transactionsType}`,
      false
    );
  }

  /* Single-document PDF, keyed by QuickBooks entity id. investmentType picks the QBO
     route - an estimate is not reachable on the invoice endpoint. */
  getInvoicePdf(qboInvoiceId: string, investmentType: number) {
    const hd = this.commonService.GetAuthorizationHeader();
    return this.commonService.API_GET(
      EndPoints.GetInvoicePdf + `/${qboInvoiceId}?investmentType=${investmentType}`,
      false,
      {
        responseType: 'blob',
        headers: hd,
      }
    );
  }

  getActivityFilters(
    siteId: any,
    startPeriod: any,
    endPeriod: any,
    searchText: any,
    transactionSubType: any,
    activityType: any,
    sortOrder: any,
    sortField: any,
    page: any,
    pageSize: any,
    isNonAlc: boolean,
    filterStatus: any
  ) {
    const payload =
      activityType == 3
        ? {
            SiteId: siteId,
            StartPeriod: startPeriod,
            EndPeriod: endPeriod,
            SearchText: searchText,
            TransactionSubType: transactionSubType,
            ActivityType: activityType,
            SortOrder: sortOrder,
            SortField: sortField,
            Page: page,
            PageSize: pageSize,
            isNonAlc: isNonAlc,
          }
        : {
            SiteId: siteId,
            SearchText: searchText,
            TransactionSubType: transactionSubType,
            ActivityType: activityType,
            SortOrder: sortOrder,
            SortField: sortField,
            Page: page,
            PageSize: pageSize,
            isNonAlc: isNonAlc,
            Status: filterStatus,
          };
    return this.commonService.API_POST(EndPoints.GetActivitiesFilter, payload, false);
  }
}
